
import CardCoin from "../../../assets/duotone/CardCoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardCoinIcon({ className, dataTestid = "CardCoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardCoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
